<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'PopPayStat',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        color: ['#00BFFF', '#FF7F50', '#BA55D3'],
        title: {
          text: '下单统计'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['弹窗总次数', '下单数', '下单成功率'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          name: '次数',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }, {
          type: 'value',
          name: '下单率',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '弹窗次数',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '下单数',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '下单成功率',
            data: [],
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
        ]
      }
    },
    refresh(data) {
      const time = []
      const popCountArr = []
      const payCountArr = []
      const payRateArr = []
      for (const i in data) {
        const val = data[i]
        time.push(dateStrTodate(val.date))
        popCountArr.push(val.data.page_count)
        payCountArr.push(val.data.pay_count)
        payRateArr.push(val.data.pay_rate)
      }
      this.option.xAxis.data = time
      this.option.series[0].data = popCountArr
      this.option.series[1].data = payCountArr
      this.option.series[2].data = payRateArr
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
